export const educationData = [
    {
        id: 1,
        course: 'BACHELOR OF TECHNOLOGY',
        startYear: '2011',
        endYear: '2015'
    },
    {
        id: 2,
        course: 'SENIOR SECONDARY',
        startYear: '2009',
        endYear: '2011'
    }
]